<div class="flex gap-2">
    <input pInputText [value]="descricao()" placeholder="Selecione o município" class="w-full" [class.readonly-input]="disabled()" readonly />
    <p-button icon="pi pi-search" [disabled]="disabled()" (onClick)="abrirDialog()" styleClass="p-button-outlined"></p-button>
</div>

<p-dialog appDialogoPadrao="pi pi-map-marker" descricao="Município do endereço do consultório." header="Selecionar Município" [(visible)]="dialogVisivel" [style]="{ width: '36rem', maxWidth: '95vw' }">
    <div class="p-2">
        <app-select-municipio #selectMunicipio [(idMunicipio)]="tempId" (cancelar)="fecharDialog()" (selecionar)="onSelecionarMunicipio($event)"></app-select-municipio>
    </div>
</p-dialog>
